export const IS_ZUIMEI = location.host.includes("zuimeitianqi.com");

export const IS_MOSTWEATHER = location.host.includes("mostweather.com");

export function isEmpty(str) {
    if (str == undefined || str === "" || str == null || str.length == 0) {
        return true;
    }
    return false;
}

export function isEmptyObject(obj) {
    // 对象是否为空
    for (var key in obj) {
        return false;
    }
    return true;
}

// 时间戳格式化
export function dateFormat(fmt, date1) {
    var date = new Date(date1);
    var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
        "w+": date.getDay(), // 星期
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
            );
        }
    }
    return fmt;
}

// 日期对应星期
export function getWeekByDay(day) {
    day = parseInt(day);
    switch (day) {
        case 0:
            return "周日";
        case 1:
            return "周一";
        case 2:
            return "周二";
        case 3:
            return "周三";
        case 4:
            return "周四";
        case 5:
            return "周五";
        case 6:
            return "周六";
        default:
            return "";
    }
}

// 对应天气类型
export function getWeaByCode(code) {
    code = parseInt(code);
    var name = "";
    switch (code) {
        case 0: //未知
            // name = "未知";
            break;
        case 1: //晴
        case 33: //晴
            name = "晴";
            break;
        case 2: //大部晴天
        case 34: //大部晴天
            name = "大部晴天";
            break;
        case 3: //部分晴天
            name = "部分晴天";
            break;
        case 4: //局部多云
        case 35: //局部多云
        case 36: //局部多云
            name = "局部多云";
            break;
        case 5: //霾
        case 37: //霾
            name = "霾";
            break;
        case 6: //大部多云
        case 38: //大部多云
            name = "大部多云";
            break;
        case 7: //多云
            name = "多云";
            break;
        case 8: //阴
            name = "阴";
            break;
        case 11: //雾
            name = "雾";
            break;
        case 12: //阵雨
            name = "阵雨";
            break;
        case 13: //大部多云伴阵雨
        case 40: //大部多云伴阵雨
            name = "大部多云伴阵雨";
            break;
        case 14: //局部晴伴阵雨
            name = "局部晴伴阵雨";
            break;
        case 15: //雷阵雨
            name = "雷阵雨";
            break;
        case 16: //大部多云伴雷阵雨
        case 42: //大部多云伴雷阵雨
            name = "大部多云伴雷阵雨";
            break;
        case 17: //局部晴伴雷阵雨
        case 41: //局部晴伴雷阵雨
            name = "局部晴伴雷阵雨";
            break;
        case 18: //雨
            name = "雨";
            break;
        case 19: //阵雪
            name = "阵雪";
            break;
        case 20: //大部多云伴阵雪
        case 43: //大部多云伴阵雪
            name = "大部多云伴阵雪";
            break;
        case 21: //局部晴伴阵雪
            name = "局部晴伴阵雪";
            break;
        case 22: //雪
            name = "雪";
            break;
        case 23: //大部多云伴雪
        case 44: //大部多云伴雪
            name = "大部多云伴雪";
            break;
        case 24: //冰
            name = "冰";
            break;
        case 25: //雨夹雪
            name = "雨夹雪";
            break;
        case 26: //冻雨
            name = "冻雨";
            break;
        case 30: //炎热
            name = "炎热";
            break;
        case 31: //寒冷
            name = "寒冷";
            break;
        case 32: //有风
            name = "有风";
            break;
        case 39: //局部多云伴阵雨
            name = "局部多云伴阵雨";
            break;
        case 45: //雷阵雨伴冰雹
            name = "雷阵雨伴冰雹";
            break;
        case 46: //小雨
            name = "小雨";
            break;
        case 47: //中雨
            name = "中雨";
            break;
        case 48: //大雨
            name = "大雨";
            break;
        case 49: //暴雨
            name = "暴雨";
            break;
        case 50: //大暴雨
            name = "大暴雨";
            break;
        case 51: //特大暴雨
            name = "特大暴雨";
            break;
        case 52: //小雪
            name = "小雪";
            break;
        case 53: //中雪
            name = "中雪";
            break;
        case 54: //大雪
            name = "大雪";
            break;
        case 55: //暴雪
            name = "暴雪";
            break;
        case 56: //沙尘暴
            name = "沙尘暴";
            break;
        case 57: //小到中雨
            name = "小到中雨";
            break;
        case 58: //中到大雨
            name = "中到大雨";
            break;
        case 59: //大到暴雨
            name = "大到暴雨";
            break;
        case 60: //暴雨到大暴雨
            name = "暴雨到大暴雨";
            break;
        case 61: //大暴雨到特大暴雨
            name = "大暴雨到特大暴雨";
            break;
        case 62: //小到中雪
            name = "小到中雪";
            break;
        case 63: //中到大雪
            name = "中到大雪";
            break;
        case 64: //大到暴雪
            name = "大到暴雪";
            break;
        case 65: //浮尘
            name = "浮尘";
            break;
        case 66: //扬沙
            name = "扬沙";
            break;
        case 67: //强沙尘暴
            name = "强沙尘暴";
            break;
        case 68: //浓雾
            name = "浓雾";
            break;
        case 69: //强浓雾
            name = "强浓雾";
            break;
        case 70: //中度霾
            name = "中度霾";
            break;
        case 71: //重度霾
            name = "重度霾";
            break;
        case 72: //严重霾
            name = "严重霾";
            break;
        case 73: //大雾
            name = "大雾";
            break;
        case 74: //特强浓雾
            name = "特强浓雾";
            break;
        case 75: //阴
            name = "阴";
            break;
        case 76: //吹雪
            name = "吹雪";
            break;
        default:
            // name = "未知";
            break;
    }
    return name;
}

// 华为天气类型转最美
export const hw2ZmMap = {
    0: 1, // 晴天
    1: 7, // 多云
    2: 8, // 	阴
    3: 12, // 阵雨
    4: 15, // 雷阵雨
    5: 45, // 雷阵雨伴有冰雹
    6: 25, // 雨夹雪
    7: 46, // 小雨
    8: 47, // 中雨
    9: 48, // 大雨
    10: 49, //暴雨
    11: 50, //大暴雨
    12: 51, //特大暴雨
    13: 19, //阵雪
    14: 52, //小雪
    15: 53, //中雪
    16: 54, //大雪
    17: 55, //暴雪
    18: 11, //雾
    19: 26, //冻雨
    20: 56, //沙尘暴
    20: 67, //沙尘暴
    21: 57, //小到中雨
    22: 58, //中到大雨
    23: 59, //大到暴雨
    24: 60, //暴雨到大暴雨
    25: 61, //大暴雨到特大暴雨
    26: 62, //小到中雪
    27: 63, //中到大雪
    28: 64, //大到暴雪
    29: 65, //浮尘
    30: 66, //扬沙
    31: 67, //强沙尘暴
    53: 5, //霾
};


export function getWeaIconByCode(id, day) {
    // 对应天气类型
    var icon = "",
        iconLight = "",
        iconBlue = "",
        iconWhite = "",
        code = parseInt(id);
    if (day == undefined) day = true;
    switch (code) {
        case 1: // 晴
        case 2: // 大部晴天
        case 3: // 部分晴天
            icon = day ? "ic_weather_sunny.svg" : "ic_weather_sunny_night.svg";
            iconLight = day
                ? "ic_weather_sunny_light.svg"
                : "ic_weather_sunny_night_light.svg";
            iconBlue = day
                ? "ic_sunny.png"
                : "ic_nightsunny@2x.png";
            iconWhite = day
                ? "ic_weather_sunny_line_white.svg"
                : "ic_weather_sunny_night_line_white.svg";
            break;
        case 4: // 局部多云
        case 6: // 大部多云
        case 7: // 多云
            icon = day
                ? "ic_weather_mostcloudy.svg"
                : "ic_weather_mostcloudy_night.svg";
            iconLight = day
                ? "ic_weather_mostcloudy_light.svg"
                : "ic_weather_mostcloudy_night_light.svg";
            iconBlue = day
                ? "ic_cloudy.png"
                : "ic_nightcloudy@2x.png";
            iconWhite = day
                ? "ic_weather_mostcloudy_line_white.svg"
                : "ic_weather_mostcloudy_night_line_white.svg";
            break;
        case 5: // 霾
        case 37: // 霾（夜）
        case 70: // 中度霾
        case 71: // 重度霾
        case 72: // 严重霾
            icon = "ic_weather_haze.svg";
            iconLight = "ic_weather_haze_light.svg";
            iconBlue = "ic_haze@2x.png";
            iconWhite = "ic_weather_haze_line_white.svg";
            break;
        case 8: // 阴
        case 75: // 阴
            icon = "ic_weather_overcast.svg";
            iconLight = "ic_weather_overcast_light.svg";
            iconBlue = "ic_overcast.png";
            iconWhite = "ic_weather_cloudy_line_white.svg";
            break;
        case 11: // 雾
        case 68: // 浓雾
        case 69: // 强浓雾
        case 73: // 大雾
        case 74: // 特强浓雾
            icon = "ic_weather_fog.svg";
            iconLight = "ic_weather_fog_light.svg";
            iconBlue = "ic_fog@2x.png";
            iconWhite = "ic_weather_fog_line_white.svg";
            break;
        case 12: // 阵雨
        case 13: // 大部多云伴有阵雨
        case 14: // 局部晴天伴有阵雨
        case 39: // 局部多云，伴有阵雨
        case 40: // 大部多云，伴有阵雨（夜）
            icon = "ic_weather_shower.svg";
            iconLight = "ic_weather_shower_light.svg";
            iconBlue = "ic_shower@2x.png";
            iconWhite = "ic_weather_shower_line_white.svg";
            break;
        case 15: // 雷阵雨
        case 16: // 大部多云伴有雷阵雨
        case 17: // 局部晴天伴有雷阵雨
        case 41: // 局部多云，伴有雷阵雨
        case 42: // 大部多云，伴有雷阵雨（夜）
        case 45: // 雷阵雨，伴有冰雹
            icon = "ic_weather_thunderstorms.svg";
            iconLight = "ic_weather_thunderstorms_light.svg";
            iconBlue = "ic_thunderstorms.png";
            iconWhite = "ic_weather_thunderstorms_line_white.svg";
            break;
        case 18: // 雨
            icon = "ic_weather_rain.svg";
            iconLight = "ic_weather_rain_light.svg";
            iconBlue = day ? "ic_lightrain@2x.png" : 'ic_nightrain@2x.png';
            iconWhite = "ic_weather_rain_line_white.svg";
            break;
        case 19: // 阵雪
        case 20: // 大部多云，伴有阵雪
        case 21: // 局部晴天，伴有阵雪
        case 22: // 雪
        case 23: // 大部多云，伴有雪
        case 43: // 大部多云，伴有阵雪（夜）
        case 44: // 大部多云，伴有雪（夜）
        case 76: // 吹雪
            icon = "ic_weather_snow.svg";
            iconLight = "ic_weather_snow_light.svg";
            iconBlue = day ? "ic_lightsnow@2x.png" : 'ic_lightsnow@2x.png';
            iconWhite = "ic_weather_snow_line_white.svg";
            break;
        case 24: // 冰
            icon = "ic_weather_cold.svg";
            iconLight = "ic_weather_cold_light.svg";
            iconBlue = "ic_lightsnow@2x.png";
            iconWhite = "ic_weather_default_line_white.svg";
            break;
        case 25: // 雨夹雪
            icon = "ic_weather_sleet.svg";
            iconLight = "ic_weather_sleet_light.svg";
            iconBlue = "ic_rainsnow@2x.png";
            iconWhite = "ic_weather_sleet_line_white.svg";
            break;
        case 26: // 冻雨
            icon = "ic_weather_freezingrain.svg";
            iconLight = "ic_weather_ice.svg";
            iconBlue = "ic_lightsnow@2x.png";
            iconWhite = "ic_weather_freezingrain_line_white.svg";
            break;
        case 30: // 炎热
            icon = "ic_weather_hot.svg";
            iconLight = "ic_weather_hot_light.svg";
            iconBlue = "ic_sunny.png";
            iconWhite = "ic_weather_hot_line_white.svg";
            break;
        case 31: // 寒冷
            icon = "ic_weather_cold.svg";
            iconLight = "ic_weather_cold_light.svg";
            iconBlue = "ic_sunny.png";
            iconWhite = "ic_weather_cold_line_white.svg";
            break;
        case 32: // 有风
            icon = "ic_weather_wind.svg";
            iconLight = "ic_weather_wind_light.svg";
            iconBlue = "ic_sunny.png";
            iconWhite = "ic_weather_wind_line_white.svg";
            break;
        case 33: // 晴（夜）
        case 34: // 大部晴天（夜）
            icon = "ic_weather_sunny_night.svg";
            iconLight = "ic_weather_sunny_night_light.svg";
            iconBlue = "ic_nightsunny@2x.png";
            iconWhite = "ic_weather_sunny_night_line_white.svg";
            break;
        case 35: // 局部多云（夜）
        case 36: // 局部多云（夜）
        case 38: // 大部多云（夜）
            icon = "ic_weather_mostcloudy_night.svg";
            iconLight = "ic_weather_mostcloudy_night_light.svg";
            iconBlue = "ic_nightcloudy@2x.png";
            iconWhite = "ic_weather_mostcloudy_night_line_white.svg";
            break;
        case 46: // 小雨
            icon = "ic_weather_rain.svg";
            iconLight = "ic_weather_rain.svg";
            iconBlue = day ? "ic_lightrain@2x.png" : "ic_nightrain@2x.png";
            iconWhite = "ic_weather_rain.svg";
            break;
        case 47: // 中雨
        case 57: // 小到中雨
            icon = "ic_weather_moderaterain.svg";
            iconLight = "ic_weather_moderaterain_light.svg";
            iconBlue = "ic_moderaterain@2x.png";
            iconWhite = "ic_weather_moderaterain_line_white.svg";
            break;
        case 48: // 大雨
        case 58: // 中到大雨
            icon = "ic_weather_heavyrain.svg";
            iconLight = "ic_weather_heavyrain_light.svg";
            iconBlue = "ic_heavyrain@2x.png";
            iconWhite = "ic_weather_heavyrain_line_white.svg";
            break;
        case 49: // 暴雨
        case 50: // 大暴雨
        case 59: // 大到暴雨
        case 60: // 暴雨到大暴雨
            icon = "ic_weather_storm.svg";
            iconLight = "ic_weather_severestorm_light.svg";
            iconBlue = "ic_rainstorm@2x.png";
            iconWhite = "ic_weather_storm_line_white.svg";
            break;
        case 51: // 特大暴雨
        case 61: // 大暴雨到特大暴雨
            icon = "ic_weather_severestorm.svg";
            iconLight = "ic_weather_severestorm_light.svg";
            iconBlue = "ic_rainstorm@2x.png";
            iconWhite = "ic_weather_severestorm_line_white.svg";
            break;
        case 52: // 小雪
            icon = "ic_weather_lightsnow.svg";
            iconLight = "ic_weather_lightsnow_light.svg";
            iconBlue = "ic_lightsnow@2x.png";
            iconWhite = "ic_weather_lightsnow_line_white.svg";
            break;
        case 53: // 中雪
        case 62: // 小到中雪
            icon = "ic_weather_moderatesnow.svg";
            iconLight = "ic_weather_moderatesnow_light.svg";
            iconBlue = "ic_moderatesnow@2x.png";
            iconWhite = "ic_weather_moderatesnow_line_white.svg";
            break;
        case 54: // 大雪
        case 63: // 中到大雪
            icon = "ic_weather_heavysnow.svg";
            iconLight = "ic_weather_heavysnow_light.svg";
            iconBlue = "ic_heavysnow@2x.png";
            iconWhite = "ic_weather_heavysnow_line_white.svg";
            break;
        case 55: // 暴雪
        case 64: // 大到暴雪
            icon = "ic_weather_snowstorm.svg";
            iconLight = "ic_weather_snowstorm_light.svg";
            iconBlue = "ic_heavysnow@2x.png";
            iconWhite = "ic_weather_snowstorm_line_white.svg";
            break;
        case 56: // 沙尘暴
        case 67: // 强沙尘暴
            icon = "ic_weather_sand.svg";
            iconLight = "ic_weather_sand_light.svg";
            iconBlue = "ic_sandstorm@2x.png";
            iconWhite = "ic_weather_sand_line_white.svg";
            break;
        case 65: // 浮尘
        case 66: // 扬沙
            icon = "ic_weather_dust.svg";
            iconLight = "ic_weather_dust.svg";
            iconBlue = "ic_dust@2x.png";
            iconWhite = "ic_weather_dust_line_white.svg";
            break;
        default:
            icon = "ic_weather_unknown.svg";
            iconLight = "ic_weather_unknown.svg";
            iconBlue = "ic_default@2x.png";
            iconWhite = "ic_weather_default_line_white.svg";
            break;
    }
    return {
        icon: icon,
        iconLight: iconLight,
        iconBlue: iconBlue,
        iconWhite: iconWhite,
    };
}

// 空气质量
export function getAqiLevelByVal(val) {
    var name = "",
        desc = "",
        color = "",
        rgba = "";

    if (val >= 0 && val <= 50) {
        name = "优";
        desc = "空气优";
        color = "#6EDA00";
        rgba = "rgba(110, 218, 0, 0.6)";
    } else if (val >= 51 && val <= 100) {
        name = "良";
        desc = "空气良";
        color = "#FFBC00";
        rgba = "rgba(255, 188, 0, 0.6)";
    } else if (val >= 101 && val <= 150) {
        name = "轻度";
        desc = "轻度污染";
        color = "#FF9100";
        rgba = "rgba(255, 145, 0, 0.6)";
    } else if (val >= 151 && val <= 200) {
        name = "中度";
        desc = "中度污染";
        color = "#FF5000";
        rgba = "rgba(255, 80, 0, 0.6)";
    } else if (val >= 201 && val <= 300) {
        name = "重度";
        desc = "重度污染";
        color = "#9811ea";
        rgba = "rgba(152, 17, 234, 0.6)";
    } else if (val >= 300 && val <= 500) {
        name = "严重";
        desc = "严重污染";
        color = "#d70707";
        rgba = "rgba(215, 7, 7, 0.6)";
    } else if (val > 500) {
        name = "严重";
        desc = "严重污染";
        color = "#d70707";
        rgba = "rgba(215, 7, 7, 0.6)";
    }

    return {
        name: name,
        desc: desc,
        color: color,
        rgba: rgba,
    };
}

// 风向
export function getWindByCode(wd) {
    var name = "",
        back = "";
    switch (wd) {
        case "NE":
            name = "东北风";
            back = "wind_direction_ne";
            break;
        case "E":
            name = "东风";
            back = "wind_direction_e";
            break;
        case "SE":
            name = "东南风";
            back = "wind_direction_se";
            break;
        case "S":
            name = "南风";
            back = "wind_direction_s";
            break;
        case "SW":
            name = "西南风";
            back = "wind_direction_sw";
            break;
        case "W":
            name = "西风";
            back = "wind_direction_w";
            break;
        case "NW":
            name = "西北风";
            back = "wind_direction_nw";
            break;
        case "N":
            name = "北风";
            back = "wind_direction_n";
            break;
        default:
            break;
    }
    return {
        name: name,
        back: back,
    };
}

// 时间转换
export function dateToTime(date) {
    return date.substr(0, 4) + "-" + date.substr(4, 2) + "-" + date.substr(6, 2);
}

export function getPixelRatio(context) {
    // canvas 适配比例
    let backingStore =
        context.backingStorePixelRatio ||
        context.webkitBackingStorePixelRatio ||
        context.mozBackingStorePixelRatio ||
        context.msBackingStorePixelRatio ||
        context.oBackingStorePixelRatio ||
        context.backingStorePixelRatio ||
        1;
    return (window.devicePixelRatio || 1) / backingStore;
}

export function mapLoader() {
    return new Promise((resolve, reject) => {
        // 全局对象如果存在地图直接将结果抛出
        if (window.AMap) {
            resolve(window.AMap);
        } else {
            // 创建script标签并放入cdn链接
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.async = true;
            script.src =
                "https://webapi.amap.com/maps?v=1.4.15&key=3246a39bec71e7acf555f45c3e3236cc&plugin=AMap.DistrictLayer&callback=initAMap";
            script.onerror = reject;
            document.head.appendChild(script);
        }
        window._AMapSecurityConfig = {
            securityJsCode: "776b95f859ebe1a53274e7c2f319206e",
        };
        window.initAMap = () => {
            // 注入相关插件
            // window.AMap.plugin(
            //   ["AMap.ToolBar", "AMap.CircleEditor", "AMap.PolyEditor"],
            //   function () {
            //     //异步同时加载多个插件
            //     var toolbar = new AMap.ToolBar();
            //     map.addControl(toolbar);
            //   }
            // );
            // 将结果抛出
            resolve(window.AMap);
        };
    });
}

// 风力等级，speed为m/s
export function getWindLevel(speed) {
    var level = 0;
    if (speed >= 0 && speed < 0.3) {
        level = 0;
    } else if (speed >= 0.3 && speed < 1.6) {
        level = 1;
    } else if (speed >= 1.6 && speed < 3.4) {
        level = 2;
    } else if (speed >= 3.4 && speed < 5.5) {
        level = 3;
    } else if (speed >= 5.5 && speed < 8.0) {
        level = 4;
    } else if (speed >= 8.0 && speed < 10.8) {
        level = 5;
    } else if (speed >= 10.8 && speed < 13.9) {
        level = 6;
    } else if (speed >= 13.9 && speed < 17.2) {
        level = 7;
    } else if (speed >= 17.2 && speed < 20.8) {
        level = 8;
    } else if (speed >= 20.8 && speed < 24.5) {
        level = 9;
    } else if (speed >= 24.5 && speed < 28.5) {
        level = 10;
    } else if (speed >= 28.5 && speed < 32.7) {
        level = 11;
    } else if (speed >= 32.7 && speed < 37.0) {
        level = 12;
    } else if (speed >= 37.0 && speed < 41.5) {
        level = 13;
    } else if (speed >= 41.5 && speed < 46.2) {
        level = 14;
    } else if (speed >= 46.2 && speed < 51) {
        level = 15;
    } else if (speed >= 51 && speed < 56.1) {
        level = 16;
    } else {
        level = 17;
    }

    return level;
}

// 台风等级名称以及对应颜色
export function getTyLevelNameAndColor(level) {
    level = level.toUpperCase();
    var name = "",
        color = "";
    switch (level) {
        case "TD":
            name = "热带低压";
            color = "#44D7B6";
            break;
        case "TS":
            name = "热带风暴";
            color = "#32C5FF";
            break;
        case "STS":
            name = "强热带风暴";
            color = "#FFE400";
            break;
        case "TY":
            name = "台风";
            color = "#EB7E21";
            break;
        case "STY":
            name = "强台风";
            color = "#B620E0";
            break;
        case "SUPERTY":
            name = "超强台风";
            color = "#E02020";
            break;
        default:
            name = "热带低压";
            color = "#44D7B6";
            break;
    }

    return {
        name: name,
        color: color,
    };
}
// 台风风向
export function getTyDir(dir) {
    var name = "";
    switch (dir) {
        case "N":
            name = "北";
            break;
        case "NNE":
            name = "东北偏北";
            break;
        case "NE":
            name = "东北";
            break;
        case "ENE":
            name = "东北偏东";
            break;
        case "E":
            name = "东";
            break;
        case "ESE":
            name = "东南偏东";
            break;
        case "SE":
            name = "东南";
            break;
        case "SSE":
            name = "东南偏南";
            break;
        case "S":
            name = "南";
            break;
        case "SSW":
            name = "西南偏南";
            break;
        case "SW":
            name = "西南";
            break;
        case "WSW":
            name = "西南偏西";
            break;
        case "W":
            name = "西";
            break;
        case "WNW":
            name = "西北偏西";
            break;
        case "NW":
            name = "西北";
            break;
        case "NNW":
            name = "西北偏北";
            break;
    }
    return name;
}

// 预警图标
export function getWarnIconByLevel(type, level) {
    type = parseInt(type);
    level = parseInt(level);
    var typeOfLevelObj = {
        icon: "ic_alert_other_unkown.svg",
        color: "",
        rgb: "",
        colors: ["#00AAEE", "#FFBF00", "#FF7500", "#FA2A2D"],
    };
    var levelMap = {
        1: {
            icon: "ic_alert_other_blue.svg",
            color: "#00AAEE",
            rgb: "rgb(0, 170, 238)",
        },
        2: {
            icon: "ic_alert_other_yellow.svg",
            color: "#FFBF00",
            rgb: "rgb(255, 191, 0)",
        },
        3: {
            icon: "ic_alert_other_orange.svg",
            color: "#FF7500",
            rgb: "rgb(255, 117, 0)",
        },
        4: {
            icon: "ic_alert_other_red.svg",
            color: "#FA2A2D",
            rgb: "rgb(250, 42, 45)",
        },
        6: {
            icon: "ic_alert_other_white.svg",
            color: "#A1A1A1",
            rgb: "rgb(161, 161, 161)",
        },
    };
    var colorsOfTypeMap = {
        1: ["#00AAEE", "#FFBF00", "#FF7500", "#FA2A2D", "#A1A1A1"], // 台风
        46: ["#00AAEE", "#FFBF00", "#FF7500", "#FA2A2D", "#A1A1A1"], // 台风
        6: ["#FFBF00", "#FF7500", "#FA2A2D"], // 沙尘暴
        8: ["#00AAEE", "#FFBF00", "#FF7500", "#FA2A2D"], // 干旱
        9: ["#00AAEE", "#FFBF00", "#FF7500", "#FA2A2D"], // 雷电
        10: ["#FFBF00", "#FF7500", "#FA2A2D"], // 冰雹
        11: ["#00AAEE", "#FFBF00", "#FF7500"], // 霜冻
        13: ["#FFBF00", "#FF7500", "#FA2A2D"], // 霾
        20: ["#FFBF00", "#FF7500", "#FA2A2D"], // 霾
        14: ["#FFBF00", "#FF7500", "#FA2A2D"], // 道路结冰
        18: ["#FFBF00", "#FF7500", "#FA2A2D"], // 森林火险
        40: ["#FFBF00", "#FF7500", "#FA2A2D"], // 森林火险
        35: ["#FFBF00", "#FF7500"], // 臭氧
    };
    var levelColorMap = {
        1: "blue",
        2: "yellow",
        3: "orange",
        4: "red",
        6: "white",
    };
    var typeNameMap = {
        1: "typhoon", // 台风
        2: "rainstorm", // 暴雨
        3: "snowstorm", // 暴雪
        4: "coldwave", // 寒潮
        5: "gale", // 大风
        6: "sandstorm", // 沙尘暴
        7: "heatwave", // 高温
        8: "drought", // 干旱
        9: "lightning", // 雷电
        10: "hail", // 冰雹
        11: "frost", // 霜冻
        12: "heavyfog", // 大雾
        13: "haze", // 霾
        14: "roadicing", // 道路结冰
        15: "other", // 其他(新增)
        17: "thundergale", // 雷电大风(新增)
        18: "forestfire", // 森林火险
        19: "cold", //寒冷(新增)
        20: "dusthaze", // 灰霾(更新)
        21: "cooling", // 降温(新增)
        22: "roadIceandSnow", // 道路冰雪(新增)
        23: "dryhotwind", // 干热风(新增)
        24: "pollution", // 空气重污染(新增)
        25: "frozen", // 冰冻(新增)
        26: "heavyfogatsea", // 海上大雾(新增)
        27: "thunderstormgale", // 雷暴大风(新增)
        28: "coldspell", // 持续低温(新增)
        29: "thickdust", // 浓浮尘(新增)
        30: "tornado", // 龙卷风(新增)
        31: "lowtemperaturefreezeinjury", // 低温冻害(新增)
        32: "galeatseal", // 海上大风(新增)
        33: "lowtemperaturefreezingrainsnow", // 低温雨雪冰冻(新增)
        34: "convection", // 强对流
        35: "ozone", // 臭氧
        36: "heavysnow", // 大雪(新增)
        37: "heavyrainfall", // 强降雨(新增)
        38: "strongcooling", // 强降温(新增)
        39: "snowdisaster", // 雪灾(新增)
        40: "forestfire", //森林（草原）火险, 跟18同一个图标，这是原有的逻辑
        41: "thunderstorm", // 雷暴(新增)
        42: "severecold", // 严寒(新增)
        43: "sanddust", // 沙尘(新增)
        44: "thunderstormandgaleatsea", // 海上雷雨大风(新增)
        45: "lightningatsea", //海上雷电(新增)
        46: "typhoonatsea", //海上台风(更新)
        47: "lowtemperature", //低温(新增)
        48: "geological", // 地质灾害
        49: "meteorologicalrisk", // 地质灾害气象风险(更新)
        50: "flushflood", // 山洪(新增)
        51: "grasslandfirerisk", // 草原火险(新增)
        52: "thunderstormandwinds", // 雷雨大风(更新)
        53: "hotwave", // 热浪(新增)
    };
    var typeLevelMap = {
        typhoon: [1, 2, 3, 4, 6],
        rainstorm: [1, 2, 3, 4],
        snowstorm: [1, 2, 3, 4],
        coldwave: [1, 2, 3, 4],
        gale: [1, 2, 3, 4],
        sandstorm: [2, 3, 4],
        heatwave: [1, 2, 3, 4],
        drought: [1, 2, 3, 4],
        lightning: [1, 2, 3, 4],
        hail: [2, 3, 4],
        frost: [1, 2, 3],
        heavyfog: [1, 2, 3, 4],
        haze: [2, 3, 4],
        roadicing: [2, 3, 4],
        other: [1, 2, 3, 4, 6],
        thundergale: [1, 2, 3, 4],
        forestfire: [1, 2, 3, 4], // 18和40复用这一个
        cold: [2, 3, 4],
        dusthaze: [2],
        cooling: [1, 2, 3, 4],
        roadIceandSnow: [1, 2, 3, 4],
        dryhotwind: [3, 4],
        pollution: [1, 2, 3, 4],
        frozen: [1, 2, 3, 4],
        heavyfogatsea: [2, 3, 4],
        thunderstormgale: [1, 2, 3, 4],
        coldspell: [1, 2, 3, 4],
        thickdust: [1, 2, 3, 4],
        tornado: [1, 2, 3, 4],
        lowtemperaturefreezeinjury: [1, 2, 3, 4],
        galeatseal: [1, 2, 3],
        lowtemperaturefreezingrainsnow: [1, 2, 3, 4],
        convection: [1, 2, 3, 4],
        ozone: [2, 3],
        heavysnow: [1, 2, 3, 4],
        heavyrainfall: [1, 2, 3, 4],
        strongcooling: [1, 2, 3, 4],
        snowdisaster: [1, 2, 3, 4],
        thunderstorm: [1, 2, 3, 4],
        severecold: [1, 2, 3, 4],
        sanddust: [1, 2, 3, 4],
        thunderstormandgaleatsea: [1, 2, 3, 4],
        lightningatsea: [1, 2, 3, 4],
        typhoonatsea: [1, 2, 3, 4],
        lowtemperature: [1, 2, 3, 4],
        geological: [1, 2, 3, 4],
        meteorologicalrisk: [1, 2, 3, 4],
        flushflood: [1, 2, 3, 4],
        grasslandfirerisk: [1, 2, 3, 4],
        thunderstormandwinds: [1, 2, 3, 4],
        hotwave: [1, 2, 3, 4],
    };
    if (levelMap.hasOwnProperty(level)) {
        // 设置初始的icon、color、rgb、
        Object.assign(typeOfLevelObj, levelMap[level]);
    }
    typeOfLevelObj.colors = colorsOfTypeMap.hasOwnProperty(type)
        ? colorsOfTypeMap[type]
        : typeOfLevelObj.colors;
    var icon = levelColorMap.hasOwnProperty(level)
        ? typeNameMap.hasOwnProperty(type)
            ? typeLevelMap[typeNameMap[type]].indexOf(level) !== -1
                ? "ic_alert_" + typeNameMap[type] + "_" + levelColorMap[level] + ".svg"
                : "ic_alert_other_" + levelColorMap[level] + ".svg"
            : "ic_alert_other_" + levelColorMap[level] + ".svg"
        : "ic_alert_other_unkown.svg";
    typeOfLevelObj.icon = icon;
    return typeOfLevelObj;
}

// 对应天气类型
export function getBackImgByCode(code) {
    let backImg = "";
    switch (code) {
        case 1: // 晴
        case 2:
        case 3:
        case 30:
        case 32:
        case 33:
        case 34:
            backImg = "bg_weather_sunny.png";
            break;
        case 4: // 多云
        case 6:
        case 7:
        case 35:
        case 36:
        case 38:
            backImg = "bg_weather_cloudy.png";
            break;
        case 8: // 阴
        case 75:
            backImg = "bg_weather_overcast.png";
            break;
        case 12: // 冰
        case 13: // 阵雨
        case 14:
        case 15: // 雨
        case 16:
        case 17:
        case 18:
        case 39:
        case 40:
        case 41:
        case 42:
        case 46:
        case 47:
        case 48:
        case 49:
        case 50:
        case 51:
        case 57:
        case 58:
        case 59:
        case 60:
        case 61:
            backImg = "bg_weather_rain.png";
            break;
        case 19: // 阵雪
        case 20: // 雪
        case 21:
        case 22:
        case 23:
        case 24:
        case 25:
        case 43:
        case 44:
        case 52:
        case 53:
        case 54:
        case 55:
        case 62:
        case 63:
        case 64:
        case 76:
            backImg = "bg_weather_snow.png";
            break;
        case 11: // 雾
        case 68:
        case 69:
        case 73:
        case 74:
            backImg = "bg_weather_haze.png";
            break;
        case 5: // 霾
        case 70:
        case 71:
        case 72:
        case 37:
            backImg = "bg_weather_haze.png";
            break;
        case 56: // 沙尘暴
        case 65:
        case 66:
        case 67:
            backImg = "bg_weather_dust.png";
            break;
        default:
            backImg = "bg_weather_sunny.png";
            break;
    }
    return {
        backImg: backImg,
    };
}

// 星座信息
export function getStarInfoByCode(code) {
    var name = "",
        line = "",
        icon = "",
        bgClass = "",
        guard = "",
        handleClass = "",
        code = parseInt(code);
    switch (code) {
        case 101: //白羊座
            name = "img_constellation_aries.png";
            line = "img_aries_top.png";
            icon = "ic_aries.png";
            bgClass = "aries";
            handleClass = "handle_aries";
            guard = "火星";
            break;
        case 102: //金牛座
            name = "img_constellation_taurus.png";
            line = "img_taurus_top.png";
            icon = "ic_taurus.png";
            bgClass = "taurus";
            handleClass = "handle_taurus";
            guard = "金星";
            break;
        case 103: //双子座
            name = "img_constellation_gemini.png";
            line = "img_gemini_top.png";
            icon = "ic_gemini.png";
            bgClass = "gemini";
            handleClass = "handle_gemini";
            guard = "水星";
            break;
        case 104: //巨蟹座
            name = "img_constellation_cancer.png";
            line = "img_cancer_top.png";
            icon = "ic_cacer.png";
            bgClass = "cancer";
            handleClass = "handle_cancer";
            guard = "月亮";
            break;
        case 105: //狮子座
            name = "img_constellation_leo.png";
            line = "img_leo_top.png";
            icon = "ic_leo.png";
            bgClass = "leo";
            handleClass = "handle_leo";
            guard = "太阳";
            break;
        case 106: //处女座
            name = "img_constellation_virgo.png";
            line = "img_virgo_top.png";
            icon = "ic_virgo.png";
            bgClass = "virgo";
            handleClass = "handle_virgo";
            guard = "水星";
            break;
        case 107: //天秤座
            name = "img_constellation_libra.png";
            line = "img_libra_top.png";
            icon = "ic_libra.png";
            bgClass = "libra";
            handleClass = "handle_libra";
            guard = "金星";
            break;
        case 108: //天蝎座
            name = "img_constellation_scorpio.png";
            line = "img_scorpio_top.png";
            icon = "ic_scorpio.png";
            bgClass = "scorpio";
            handleClass = "handle_scorpio";
            guard = "冥王星";
            break;
        case 109: //射手座
            name = "img_constellation_sagittarius.png";
            line = "img_sagittarius_top.png";
            icon = "ic_sagittarius.png";
            bgClass = "sagittarius";
            handleClass = "handle_sagittarius";
            guard = "木星";
            break;
        case 110: //摩羯座
            name = "img_constellation_capricornus.png";
            line = "img_capricornus_top.png";
            icon = "ic_capricom.png";
            bgClass = "acapricornus";
            handleClass = "handle_acapricornus";
            guard = "土星";
            break;
        case 111: //水瓶座
            name = "img_constellation_aquarius.png";
            line = "img_aquarius_top.png";
            icon = "ic_aquarius.png";
            bgClass = "aquarius";
            handleClass = "handle_aquarius";
            guard = "天王星";
            break;
        case 112: //双鱼座
            name = "img_constellation_pisces.png";
            line = "img_pisces_top.png";
            icon = "ic_pisces.png";
            bgClass = "pisces";
            handleClass = "handle_pisces";
            guard = "海王星";
            break;
    }
    return {
        name: name,
        line: line,
        icon: icon,
        bgClass: bgClass,
        handleClass: handleClass,
        guard: guard,
    };
}

/**
 * WGS-84 转 GCJ-02 (GPS坐标 → 高德坐标)
 * @param {number} lng 经度
 * @param {number} lat 纬度
 * @returns {[number, number]} 转换后的[经度, 纬度]
 */
export function wgs84ToGcj02(lng, lat) {
    if (outOfChina(lng, lat)) {
        return [lng, lat];
    }

    const d = delta(lng, lat);
    return [lng + d[0], lat + d[1]];
}

/**
 * GCJ-02 转 WGS-84 (高德坐标 → GPS坐标)
 * @param {number} lng 经度
 * @param {number} lat 纬度
 * @returns {[number, number]} 转换后的[经度, 纬度]
 */
export function gcj02ToWgs84(lng, lat) {
    //   return [lng, lat];
    if (outOfChina(lng, lat)) {
        return [lng, lat];
    }

    const d = delta(lng, lat);
    return [lng - d[0], lat - d[1]];
}

// 辅助函数：计算偏移量
function delta(lng, lat) {
    const a = 6378245.0; // 地球长半轴
    const ee = 0.00669342162296594323; // 偏心率平方

    let dLng = transformLng(lng - 105.0, lat - 35.0);
    let dLat = transformLat(lng - 105.0, lat - 35.0);

    const radLat = (lat / 180.0) * Math.PI;
    const magic = Math.sin(radLat);
    const magic1 = 1 - ee * magic * magic;
    const sqrtMagic = Math.sqrt(magic1);

    dLng = (dLng * 180.0) / (a / sqrtMagic * Math.cos(radLat) * Math.PI);
    dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic1 * sqrtMagic) * Math.PI);

    return [dLng, dLat];
}

// 纬度转换
function transformLat(x, y) {
    let ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
    ret += (20.0 * Math.sin(6.0 * x * Math.PI) + 20.0 * Math.sin(2.0 * x * Math.PI)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(y * Math.PI) + 40.0 * Math.sin(y / 3.0 * Math.PI)) * 2.0 / 3.0;
    ret += (160.0 * Math.sin(y / 12.0 * Math.PI) + 320 * Math.sin(y * Math.PI / 30.0)) * 2.0 / 3.0;
    return ret;
}

// 经度转换
function transformLng(x, y) {
    let ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
    ret += (20.0 * Math.sin(6.0 * x * Math.PI) + 20.0 * Math.sin(2.0 * x * Math.PI)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(x * Math.PI) + 40.0 * Math.sin(x / 3.0 * Math.PI)) * 2.0 / 3.0;
    ret += (150.0 * Math.sin(x / 12.0 * Math.PI) + 300.0 * Math.sin(x / 30.0 * Math.PI)) * 2.0 / 3.0;
    return ret;
}

// 判断是否在中国境内
function outOfChina(lng, lat) {
    // 经度范围
    if (lng < 72.004 || lng > 137.8347) {
        return true;
    }

    // 纬度范围
    if (lat < 0.8293 || lat > 55.8271) {
        return true;
    }

    return false;
}

export function indexFontIcon(name) {
    let icon = "",
        bgc = "";
    //加图标
    if (name === "穿衣指数") {
        //1
        icon = "icon-index-ic_life_dress";
        bgc = "rgba(98, 54, 255, 0.05)"
    } else if (name === "运动指数") {
        //2
        icon = "icon-index-ic_life_sports_new";
        bgc = "RGBA(254, 251, 242, 1)"
    } else if (name === "感冒指数") {
        //3
        icon = "icon-index-ic_life_cold_new";
    } else if (name === "洗车指数") {
        //4
        icon = "icon-index-ic_life_washingcar_new";
    } else if (name === "旅游指数") {
        //5
        icon = "icon-index-ic_lifeindex_tour_new";
        bgc = "rgba(245, 253, 251, 1)"
    } else if (name === "紫外线指数") {
        icon = ""; //缺
    } else if (name === "防晒指数") {
        icon = "icon-index-ic_life_sunscreen_new";
    } else if (name === "钓鱼指数") {
        icon = "icon-index-ic_life_fishing_new";
    } else if (name === "化妆指数") {
        icon = "icon-index-ic_life_skateboarding";
    } else if (name === "晨练指数") {
        icon = "icon-index-ic_life_exercise";
    } else if (name === "划船指数") {
        icon = "icon-index-ic_life_boating";
    } else if (name === "放风筝指数") {
        icon = "icon-index-ic_life_kite_new";
    } else if (name === "跑步指数") {
        icon = "icon-index-ic_life_running_new";
    } else if (name === "骑单车指数") {
        icon = "icon-index-ic_life_bike";
    } else if (name === "交通指数") {
        icon = "icon-index-ic_life_traffic";
    } else if (name === "空气污染扩散条件指数") {
        icon = ""; //缺
    } else if (name === "晾晒指数") {
        //20
        icon = "";
    } else if (name === "舒适度指数") {
        //22
        icon = "icon-index-ic_life_comfort";
    } else if (name === "空调开启指数") {
        icon = ""; //缺
    } else if (name === "过敏指数") {
        //24
        icon = "icon-index-ic_life_irritability_new";
    } else if (name === "网球指数") {
        //29
        icon = "icon-index-ic_life_tennis_new";
    } else if (name === "高尔夫指数") {
        icon = "icon-index-ic_life_golf";
    } else if (name === "滑雪指数") {
        icon = "icon-index-ic_life_skiing_new";
    } else if (name === "航班延误") {
        icon = "icon-index-ic_life_washingcar_new"; //缺
    } else if (name === "观星指数") {
        //34
        icon = "icon-index-ic_life_star";
    } else if (name === "徒步指数") {
        icon = "icon-index-ic_life_foot_new";
    } else if (name === "户外演唱会指数") {
        icon = "icon-index-ic_life_vocal";
    } else if (name === "海滩指数") {
        icon = "icon-index-ic_life_beach_new";
    } else if (name === "购物指数") {
        icon = "icon-index-ic_life_shopping_new";
    } else if (name === "关节疼痛指数") {
        icon = "icon-index-ic_life_joint";
    } else if (name === "哮喘指数") {
        icon = "icon-index-ic_life_asthma";
    }

    return {
        icon: icon,
        bgc: bgc
    };
}
export function getDefenseGuide(type) {
    const warningMeasuresMap = {
        5: [
            {
                icon: "ic_alert_window.svg",
                text: "关闭门窗",
            },
            {
                icon: "ic_alert_falling.svg",
                text: "小心坠物",
            },
            {
                icon: "ic_alert_billboards.svg",
                text: "远离广告牌",
            },
        ],
        2: [
            {
                icon: "ic_alert_carry_umbrella.svg",
                text: "携带雨伞",
            },
            {
                icon: "ic_alert_road_conditions.svg",
                text: "关注路况",
            },
            {
                icon: "ic_alert_falling.svg",
                text: "小心坠物",
            },
        ],
        7: [
            {
                icon: "ic_alert_replenish_water.svg",
                text: "补充水分",
            },
            {
                icon: "ic_alert_attention_sunscreen.svg",
                text: "注意防晒",
            },
            {
                icon: "ic_alert_heatstroke_prevention.svg",
                text: "防暑降温",
            },
        ],
        9: [
            {
                icon: "ic_alert_indoor_activities.svg",
                text: "室内活动",
            },
            {
                icon: "ic_alert_window.svg",
                text: "关闭门窗",
            },
            {
                icon: "ic_alert_cutoff_power.svg",
                text: "切断电源",
            },
        ],
        1: [
            {
                icon: "ic_alert_indoor_activities.svg",
                text: "室内活动",
            },
            {
                icon: "ic_alert_window.svg",
                text: "关闭门窗",
            },
            {
                icon: "ic_alert_falling.svg",
                text: "小心坠物",
            },
        ],
        46: [
            {
                icon: "ic_alert_indoor_activities.svg",
                text: "室内活动",
            },
            {
                icon: "ic_alert_window.svg",
                text: "关闭门窗",
            },
            {
                icon: "ic_alert_falling.svg",
                text: "小心坠物",
            },
        ],
        3: [
            {
                icon: "ic_alert_road_conditions.svg",
                text: "关注路况",
            },
            {
                icon: "ic_alert_keep_warm.svg",
                text: "注意保暖",
            },
            {
                icon: "ic_alert_falling.svg",
                text: "小心坠物",
            },
        ],
        4: [
            {
                icon: "ic_alert_keep_warm.svg",
                text: "注意保暖",
            },
            {
                icon: "ic_alert_window.svg",
                text: "关闭门窗",
            },
            {
                icon: "ic_alert_reduce_travel.svg",
                text: "减少出行",
            },
        ],
        6: [
            {
                icon: "ic_alert_wear_mask.svg",
                text: "戴好口罩",
            },
            {
                icon: "ic_alert_window.svg",
                text: "关闭门窗",
            },
            {
                icon: "ic_alert_reduce_travel.svg",
                text: "减少出行",
            },
        ],
        8: [
            {
                icon: "ic_alert_timely_irrigation.svg",
                text: "及时灌溉",
            },
            {
                icon: "ic_alert_water_saving.svg",
                text: "节约用水",
            },
            {
                icon: "ic_alert_bewareof_fire.svg",
                text: "谨防火灾",
            },
        ],
        10: [
            {
                icon: "ic_alert_falling.svg",
                text: "小心坠物",
            },
            {
                icon: "ic_alert_indoor_activities.svg",
                text: "室内活动",
            },
            {
                icon: "ic_alert_window.svg",
                text: "关闭门窗",
            },
        ],
        11: [
            {
                icon: "ic_alert_keep_warm.svg",
                text: "注意保暖",
            },
            {
                icon: "ic_alert_road_conditions.svg",
                text: "关注路况",
            },
            {
                icon: "ic_alert_window.svg",
                text: "关闭门窗",
            },
        ],
        12: [
            {
                icon: "ic_alert_road_conditions.svg",
                text: "关注路况",
            },
            {
                icon: "ic_alert_slowdown.svg",
                text: "减速慢行",
            },
            {
                icon: "ic_alert_reduce_travel.svg",
                text: "减少出行",
            },
        ],
        13: [
            {
                icon: "ic_alert_wear_mask.svg",
                text: "戴好口罩",
            },
            {
                icon: "ic_alert_indoor_activities.svg",
                text: "室内活动",
            },
            {
                icon: "ic_alert_window.svg",
                text: "关闭门窗",
            },
        ],
        20: [
            {
                icon: "ic_alert_wear_mask.svg",
                text: "戴好口罩",
            },
            {
                icon: "ic_alert_indoor_activities.svg",
                text: "室内活动",
            },
            {
                icon: "ic_alert_window.svg",
                text: "关闭门窗",
            },
        ],
        14: [
            {
                icon: "ic_alert_road_conditions.svg",
                text: "关注路况",
            },
            {
                icon: "ic_alert_slowdown.svg",
                text: "减速慢行",
            },
            {
                icon: "ic_alert_non_slip.svg",
                text: "注意防滑",
            },
        ],
        43: [
            {
                icon: "ic_alert_window.svg",
                text: "关闭门窗",
            },
            {
                icon: "ic_alert_falling.svg",
                text: "小心坠物",
            },
            {
                icon: "ic_alert_billboards.svg",
                text: "远离广告牌",
            },
        ],
    };

    return warningMeasuresMap[type] || [];
}

export function healthGuideCopywriting(type) {
    let data = {
        优: {
            outroom: "非常适宜户外",
            mask: "无需佩戴",
            purification: "不需要开启",
            windows: "开窗通风",
            icon: "ic_aqi_info_01.svg",
            backImg: "img_aqi_top_01.svg",
        },
        良: {
            outroom: "非常适宜户外",
            mask: "无需佩戴",
            purification: "敏感人群开启",
            windows: "可以开窗透气",
            icon: "ic_aqi_info_02.svg",
            backImg: "img_aqi_top_02.svg",
        },
        轻度: {
            outroom: "不太适合户外",
            mask: "建议佩戴",
            purification: "建议开启",
            windows: "不宜开窗",
            icon: "ic_aqi_info_03.svg",
            backImg: "img_aqi_top_03.svg",
        },
        中度: {
            outroom: "不适合户外",
            mask: "建议佩戴",
            purification: "需要开启",
            windows: "不适应开窗",
            icon: "ic_aqi_info_04.svg",
            backImg: "img_aqi_top_04.svg",
        },
        重度: {
            outroom: "不要去户外",
            mask: "需要佩戴",
            purification: "长时间开启",
            windows: "关闭窗户",
            icon: "ic_aqi_info_05.svg",
            backImg: "img_aqi_top_05.svg",
        },
        严重: {
            outroom: "非常不适宜户外",
            mask: "务必佩戴",
            purification: "全天开启",
            windows: "关闭窗户",
            icon: "ic_aqi_info_06.svg",
            backImg: "img_aqi_top_06.svg",
        },
    };
    return data[type];
}
export function getStarDesc(type) {
    let starRatingMap = {
        1: {
            text: '1星',
            starRating: '看不见'
        },
        2: {
            text: '2星',
            starRating: '极难看见'
        },
        3: {
            text: '3星',
            starRating: '有机会'
        },
        4: {
            text: '4星',
            starRating: '能看见'
        },
        5: {
            text: '5星',
            starRating: '清晰可见'
        }
    }
    return starRatingMap[type] || {};
}

//获取页面
export function getPageId() {
    const url = window.location.hash;

    const pageMapping = {
        '/index': 'H1',
        '/map': 'H22',
        '/services': 'H5',
        '/calendar': 'H15',
        '/air': 'H3',
        '/warning': 'H13',
        '/astronomy': 'H4',
        '/typhoon': 'H27',
        '/flower': 'H118_10',
        '/news': 'H58',
        '/about': 'H145'
    };
    for (const [key, value] of Object.entries(pageMapping)) {
        if (url.includes(key)) {
            return value;
        }
    }

    return 'H0';
}